import { gql } from "apollo-boost"

export const getTechnicalUpdatesBySubmissionQuery = gql`
  query TechnicalUpdatesBySubmission($id: ID!){
    TechnicalUpdatesBySubmission(id: $id){
      id
      createdAt
      obstacles
      updateType
      challenges
      correctiveActions      
      successDeclarations
    }
  }
`